module.exports = __webpack_public_path__ + "static/media/StartScreen_Adelphi_1920x1080.d866f983.png";